/**
 * 事件总线
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */

import Vue from 'vue'
export default new Vue({
  methods: {
    //发送通知
    emit(event, ...args) {
      this.$emit(event, ...args);
    },
    //订阅通知
    on(event, callback) {
      this.$on(event, callback);
    },
    //删除已订阅
    off(event, callback) {
      this.$off(event, callback);
    }
  }
});